import { WidgetStyledProps } from "@components/widgets/base/widget";
import { WIDGET_STYLE_TYPE } from "@resources/Constants";
import styled from "styled-components";

export const RetailVisitorAreaTrafficStyled = styled.div`
  display: flex;
  height: 100%;
`;

export const ContainerStyled = styled.div`
  height: 100%;
`;

export const GridItemLeft = styled.div<WidgetStyledProps>`
  width: ${({ styleType }) =>
    styleType === WIDGET_STYLE_TYPE.MAIN ? "100%" : "50%"};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const GridItemRight = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ColorDot = styled.div<{ color: string }>`
  background: ${({ color }) => color};
  width: 8px;
  height: 8px;
  border-radius: 8px;
`;

export const LocationWrapper = styled.div`
  display: flex;
  gap: 5px;
  justify-content: start;
  align-items: center;
`;

export const LegendWrapper = styled.div`
  padding-left: 8px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(67px, 1fr));
  gap: 4px;
  max-width: 100%;
`;

export const Legend = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  font-weight: 400;
  font-size: var(--hv-fontsize-body-xs);
  color: var(--hv-text-normal-secondary);
  padding: 4px;
`;

export const LegendText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
`;

export const SwitchWrapper = styled.div`
  width: 160px;
`;

export const LegendDropdown = styled.div`
  display: block;
  position: absolute;
  top: 26px;
  left: 0;
  background-color: var(--hv-surface-popup);
  color: var(--hv-text-normal-primary);
  border: 1px solid var(--hv-border-default);
  border-radius: 5px;
  box-shadow: var(--hv-shadow-1);
  z-index: 1000;
  min-width: 100px;
  padding: 3px 0px;
`;

export const LegendMore = styled.div`
  position: relative;
`;

export const SmallText = styled.p`
  font-weight: 400;
  font-size: var(--hv-fontsize-body-xs);
  line-height: 12px;
  text-align: center;
  color: var(--hv-text-normal-tertiary);
`;

export const ToolTipTitle = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;
